import packageJson from "../../../package.json";
import {Layout} from "antd";

const TempoComptaFooter = () => {
    return <Layout.Footer style={{textAlign: "center"}}>
        Tempo Compta 2022-2025 © Created by Jules Frère - Version {packageJson.version}
    </Layout.Footer>
}

export default TempoComptaFooter;
